import React from 'react';

import ExpertCard from 'component/Incentive/TravelExpert/Card';

import { ServiceInformation } from 'proto/ServiceInformation';

import { useExpertList } from './__hook/useExpertList';

interface TravelExpertProps {
    serviceInformation?: ServiceInformation;
}

export const TravelExpertWrapper = ({
    serviceInformation,
}: TravelExpertProps) => {
    const { chatBot, expertList } = useExpertList();

    if (!expertList.items.length && !chatBot) {
        return null;
    }

    return (
        <ExpertCard
            expert={expertList}
            serviceCode={serviceInformation?.code}
            chatBotData={chatBot}
        />
    );
};
